module.exports = __webpack_public_path__ + "static/media/arrow_blue.4116ab77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow_blue.svg
// module id = 1373
// module chunks = 0